import { render, staticRenderFns } from "./vigilantes.vue?vue&type=template&id=f3d21b78&scoped=true"
import script from "./vigilantes.vue?vue&type=script&lang=js"
export * from "./vigilantes.vue?vue&type=script&lang=js"
import style0 from "./vigilantes.vue?vue&type=style&index=0&id=f3d21b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d21b78",
  null
  
)

export default component.exports